import React, { useState } from "react";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import {
  Box,
  LinearProgress,
  TablePagination,
  Typography,
} from "@mui/material";
import { INITIAL_DATA_TABLE_LIMIT } from "utils";
import CustomNoRowsOverlay from "./CustomNoRowsOverlay";

const Table = ({
  checkboxSelection,
  rows,
  refetch,
  rowHeight,
  columns,
  isHiddenColumnFeature,
  isFilterFeature,
  isExportFeature,
  loading,
  selectionModel,
  setSelectionModel,
  title,
  totalCount,
  fetchMore,
  pgSize,
  style,
  AddButton,
  autoHeight,
  hidePagination,
  isLocalSort,
  rowId,
}) => {
  const [pageSize, setPageSize] = useState(
    pgSize ? pgSize : INITIAL_DATA_TABLE_LIMIT
  );
  const [page, setPage] = useState(0);

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {isHiddenColumnFeature ? <GridToolbarColumnsButton /> : null}
        {isFilterFeature ? <GridToolbarFilterButton /> : null}
        {isExportFeature ? <GridToolbarExport /> : null}
      </GridToolbarContainer>
    );
  }

  const handlePageSizeChange = (event) => {
    let size = parseInt(event.target.value, 10);
    setPageSize(size);
    setPage(0);
    fetchMore({
      variables: {
        first: size,
      },
    });
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    fetchMore({
      variables: {
        first: pageSize,
        offset: newPage * pageSize,
      },
    });
  };

  const handleSortModelChange = React.useCallback((sortModel) => {
    if (isLocalSort) return;
    let sortingQuery = sortModel[0];
    if (sortingQuery) {
      let sortField = `${sortingQuery.sort === "asc" ? "" : "-"}${
        sortingQuery.field
      }`;
      fetchMore({
        variables: {
          orderBy: sortField,
        },
      });
    }
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        position: "relative",
        ...style,
      }}
    >
      <DataGrid
        checkboxSelection={checkboxSelection}
        getRowId={(row) => (rowId ? row[rowId] : row.objectId)}
        keepNonExistentRowsSelected
        onSelectionModelChange={(ids) => {
          setSelectionModel(ids);
        }}
        selectionModel={selectionModel}
        sortingMode={isLocalSort ? "client" : "server"}
        columns={columns}
        autoHeight={autoHeight ?? true}
        density="compact"
        rows={rows}
        pagination
        paginationMode="server"
        hideFooter={hidePagination}
        rowHeight={rowHeight ? rowHeight : 60}
        loading={loading}
        rowCount={totalCount ? totalCount : 0}
        disableColumnMenu
        hideFooterPagination={true}
        onSortModelChange={handleSortModelChange}
        disableSelectionOnClick
        slots={{
          // loadingOverlay: LinearProgress,
          noRowsOverlay: CustomNoRowsOverlay,
          toolbar: CustomToolbar,
        }}
      />
      {hidePagination ? null : (
        <Box sx={{ position: "absolute", bottom: "0px", right: 1 }}>
          <TablePagination
            component="div"
            count={totalCount ? totalCount : 0}
            page={page}
            rowsPerPage={pageSize}
            rowsPerPageOptions={[25, 100, 500, 1000]}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handlePageSizeChange}
          />
        </Box>
      )}
    </Box>
  );
};

export default Table;
